let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cpfd5")).then(() => parcelRequire('a6mRS'));